module.exports = __webpack_public_path__ + "img/register.04124d53.svg";